<template>
  <div class="pb-12">
    <v-row no-gutters>
      <v-col
        id="finished"
        :cols="$vuetify.breakpoint.mdAndUp && !$route.query.embed ? '8' : '12'"
      >
        <Finished />

        <Gamification
          v-if="finalDetails?.orderData?.gamification"
          :urlGamification="gamificationUrl"
        />
      </v-col>
      <v-col
        v-if="!$route.query.embed"
        :style="$vuetify.breakpoint.mdAndUp ? '' : 'background-color: #eee'"
        :cols="$vuetify.breakpoint.mdAndUp ? '4' : '12'"
      >
        <Summary />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Summary from "../components/summary/Index.vue";
import { mapGetters } from "vuex";
import Finished from "../components/finished/Index.vue";
import Gamification from "../components/finished/Gamification/Index.vue";
export default {
  components: { Summary, Finished, Gamification },
  computed: {
    ...mapGetters([
      "orderDetails",
      "buyer",
      "paymentOption",
      "productsTotal",
      "eventDetails",
      "storeDetails",
      "cartProducts",
      "totalWithoutTax",
      "eventId",
      "finalDetails",
    ]),
    facebookPixel() {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === "facebook_pixel"
      )?.credenciais?.token;
    },

    googleAnalytics() {
      return this.findTokenPerType("google_analytics");
    },
    googleAds() {
      return this.findTokenPerType("google_ads");
    },
    tiktokPixel() {
      return this.findTokenPerType("tiktok");
    },

    gamificationUrl() {
      if (this.finalDetails?.orderData?.gamification) {
        return `${this.storeDetails.apiUrl}/api/event/gamification/ranking/${this.eventId}/${this.finalDetails?.orderData?.gamification?.chave}/html`;
      }

      return "";
    },
  },
  mounted() {
    console.log("this.orderDetails", this.orderDetails);
    if (!this.orderDetails)
      this.$router.push({
        name: "Cart",
        params: { event: this.eventId },
        query: this.$route.query,
      });
    else {
      localStorage.removeItem(`cart-order-route-${this.eventId}`);
      this.addFacebookPixel();
      this.analytics();
    }
    this.handleScrollTo(
      "#finished",
      this.$vuetify.breakpoint.mdAndUp ? -64 : -40
    );
  },
  destroyed() {
    localStorage.removeItem(`cart-order-route-${this.eventId}`);
    localStorage.removeItem(`isCouponCard-${this.eventId}`);
    localStorage.removeItem(`couponCode-${this.eventId}`);
    this.$store.dispatch("resetPurchase");
  },
  methods: {
    async addFacebookPixel() {
      let metaPixelStore = this.storeDetails?.configs?.metaPixel;

      if (this.facebookPixel) {
        const facebookIntegrations =
          this.eventDetails?.integracoes_publicas.filter(
            (integration) => integration.tipo === "facebook_pixel"
          );

        facebookIntegrations.forEach((integration) => {
          var mf = document.createElement("img");
          mf.src = `https://www.facebook.com/tr?id=${integration.credenciais.token}&ev=Purchase&eid=${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}&currency=BRL&value=${this.totalWithoutTax}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

          mf.src += `&cd[contents][0][id]=${`${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}`}&cd[contents][0][quantity]=1`;

          mf.src = this.incrementStringInSrc(mf.src);

          mf.style = "display:none;";
          mf.height = 1;
          mf.width = 1;
          document.getElementsByTagName("head")[0].appendChild(mf);
        });
      }

      if (metaPixelStore) {
        var img = document.createElement("img");
        img.src = `https://www.facebook.com/tr?id=${metaPixelStore}&ev=Purchase&eid=${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}&currency=BRL&value=${this.totalWithoutTax}&cd[currency]=BRL&cd[value]=${this.totalWithoutTax}&cd[content_type]=product`;

        img.src += `&cd[contents][0][id]=${`${this.orderDetails.codigo_evento}-${this.orderDetails.codigo_pedido}`}&cd[contents][0][quantity]=1`;

        img.src = await this.incrementStringInSrc(img.src);

        img.style = "display:none;";
        img.height = 1;
        img.width = 1;
        document.getElementsByTagName("head")[0].appendChild(img);
      }
    },

    incrementStringInSrc(src) {
      let newSrc = src;

      this.cartProducts.forEach((products) => {
        products.forEach((product, index) => {
          newSrc += `&cd[contents][${index + 1}][id]=${
            product.codigo_produto
          }&cd[contents][${index + 1}][quantity]=${product.quantidade}`;
        });
      });

      return newSrc;
    },

    analytics() {
      if (this.googleAnalytics) this.gAnalytics();
      if (this.googleAnalytics) this.startGtag();
      if (this.googleAds) this.googleAdsPayment();
      if (this.tiktokPixel) this.addTiktoPixel();
    },

    async startGtag() {
      this.$gtag.event("Compra", {
        send_to: `${
          this.isLetter(String(this.googleAnalytics).charAt(0)) ? "" : "UA-"
        }${this.googleAnalytics}`,
        transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        event_category: "ecommerce",
        event_label: "Total",
        currency: "BRL",
        value: this.productsTotal,
        event_value: this.productsTotal,
      });

      this.$gtag.event("Compra", {
        send_to: this.storeDetails?.configs?.googleAnalytics,
        transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        event_category: "ecommerce",
        event_label: "Total",
        currency: "BRL",
        value: this.productsTotal,
        event_value: this.productsTotal,
      });
    },

    gAnalytics() {
      let products = [];
      this.cartProducts.forEach((item) => {
        item.forEach((p) => {
          let product = {
            id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
            name: `${this.eventDetails.nome} - ${p.nome}`,
            sku: String(p.codigo_produto),
            category: "Evento",
            price: p.valor,
            quantity: p.quantidade,
          };
          products.push(product);
        });
      });

      this.$gtag.purchase({
        send_to: `${
          this.isLetter(String(this.googleAnalytics).charAt(0)) ? "" : "UA-"
        }${this.googleAnalytics}`,
        transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        value: this.productsTotal,
        currency: "BRL",
        items: products,
      });

      this.$gtag.purchase({
        send_to: this.storeDetails?.configs?.googleAnalytics,
        transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        value: this.productsTotal,
        currency: "BRL",
        items: products,
      });
    },
    addTiktoPixel() {
      window.ttq.track("CompletePayment", {
        product_group: "product_group",
        content_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        content_category: "ecommerce",
        value: this.productsTotal,
        description: "Total",
        currency: "BRL",
      });
    },
    async googleAdsPayment() {
      this.$gtag.event("conversion", {
        send_to: this.googleAds,
        transaction_id: `${this.eventId}-${this.orderDetails.codigo_pedido}`,
        event_category: "Compra",
        event_label: "Total",
        currency: "BRL",
        value: String(this.productsTotal),
        event_value: String(this.productsTotal),
      });
    },

    handleScrollTo(element, ofs) {
      this.$scrollTo(element, 500, {
        offset: ofs,
      });
    },

    findTokenPerType(type) {
      return this.eventDetails?.integracoes_publicas?.find(
        (i) => i.tipo === type
      )?.credenciais?.token;
    },

    isLetter(str) {
      return /[a-zA-Z]/.test(str);
    },
  },
};
</script>
